import { HttpParams } from '@angular/common/http';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { debounceTime, distinctUntilChanged, Subject, Subscription } from 'rxjs';
import { ConfirmationDialogeComponent } from 'src/app/Genric/confirmation-dialoge/confirmation-dialoge.component';
import { Booking, BookingCancellationReason, CancellationDetails, ChatMessage, PaginatedBookingResponse, RegionsWithId } from 'src/app/Models/booking';
import { BookingService } from 'src/app/Services/booking.service';
import { ConfirmationServiceService } from 'src/app/Services/confirmation-service.service';
import { CustomToasterServiceService } from 'src/app/Services/custom-toaster-service.service';
import { UsersService } from 'src/app/Services/users.service';

@Component({
  selector: 'app-booking',
  templateUrl: './booking.component.html',
  styleUrls: ['./booking.component.css'],
})
export class BookingComponent {
  @ViewChild('closeBtn') closeBtn!: ElementRef;
  toursection: boolean = true
  messagesection: boolean = false
  paymentsection: boolean = false
  RegionFilter: number | string = '';
  filteredUsers: Booking[] = [];
  bookings: Booking[] = [];
  confirmedBookings: any[] = [];
  pageNumber = 1;
  allbookingarray: number[] = []
  upcomingbookingarray: number[] = []
  completebookingarray: number[] = []
  selectedBooking: Booking | null = null;
  selectedFiltertype = '';
  allbokingnumber: number = 0
  isLoading = false;
  upcomingBookingsCount: number = 0
  cancelledBookingsCount: number = 0
  comingBookingsCount: number = 0
  totalBookings = 0;
  SelectededtouristUserId: number | null = null
  SelectedtourGuideUserId: number | null = null
  totalPages: number = 0
  jumpPageInput: number = 0
  selectedStatus: string = ''
  reasonvisiable: boolean = false

  ngOnDestroy(): void {
    if (this.searchSubscription) {
      this.searchSubscription.unsubscribe();
    }
  }
  ngOnInit(): void {
    this.getRegionName();
    this.toggleView('allbooking');
    this.modifiedloadAllBookings();


    this.searchAllSubject.pipe(debounceTime(500), distinctUntilChanged())
      .subscribe(search => {
        this.searchAll = search;
        this.modifiedloadAllBookings();
      });
    this.occancelbooking()


    const storedData = sessionStorage.getItem('userData');
    const newProfilePhoto = sessionStorage.getItem('ProfileImage');
    if (storedData) {
      const parsedData = JSON.parse(storedData);


      this.UserId = parsedData.userId;

    }
  }

  constructor(private bookingservice: BookingService, private toaster: CustomToasterServiceService, private userservice: UsersService, private confirmDialogService: ConfirmationServiceService) { }
  viewMode: 'allbooking' | 'upcoming' | 'complete' | 'canceled' | 'expired' = 'allbooking';
  viewbooking: 'tourdetails' | 'messages' | 'paymentdetails' = 'tourdetails';


  private searchSubject = new Subject<string>();
  private searchSubscription!: Subscription;
  messageturns(selectedBooking: Booking | null) {
     

    if (selectedBooking) {


      this.SelectededtouristUserId = selectedBooking.userId;
      this.SelectedtourGuideUserId = selectedBooking.tourGuideUserId;



      this.getChatHistory(this.SelectededtouristUserId, this.SelectedtourGuideUserId)
    }
    else {
      this.toaster.error("Not Selected Booking Properly")
    }
    this.toursection = false
    this.paymentsection = false
    this.messagesection = true
  }
  regionsName: RegionsWithId[] = [];
  allBookings: Booking[] = [];
  upcomingBookings: Booking[] = [];
  completedBookings: Booking[] = [];
  canceledBookings: Booking[] = [];
  chatHistory: ChatMessage[] = [];
  totalbookingpage = 0;
  pageSize = 10;
  allPage = 1;
  upcomingPage = 1;
  totalcomplete = 0;
  completePage = 1;
  totalcompletepage = 0
  totalcanceledpage = 0
  cancelPage = 1;
  allbookingsuser = 0
  totalconfirm = 0
  totalconfirmpage = 0
  searchText = '';
  completesearchText = ''
  selecetedBookingStatus: string = ''
  searchAll = '';
  searchUpcoming = '';
  searchComplete = '';
  searchCancel = '';
  selectedDateFilter = ''
  BookingTotalCount: number = 0
  private searchAllSubject = new Subject<string>();
  getresonofcancel: BookingCancellationReason[] = []

  bookingcanceldetails: CancellationDetails = {
    sendToEmail: '',
    reciversName: '',
    touristName: '',
    tourGuideName: '',
    tourstartDate: '',
    tourEndDate: '',
    tourDestination: '',
    bookingId: 0,
    cancelledByRole: '',
    cancelledOn: '',
    cancellationReason: ''
  };





  onRegionChange() {
    this.RegionFilter = this.RegionFilter
    this.allPage = 1
    this.modifiedloadAllBookings()
  }


  onStatusChange() {
    this.selectedDateFilter = this.selectedFiltertype
    this.allPage = 1
    this.modifiedloadAllBookings()
  }




  tourturns() {
     
    this.toursection = true
    this.paymentsection = false
    this.messagesection = false
  }
  paymentturns() {
    this.toursection = false
    this.paymentsection = true
    this.messagesection = false
  }


  getStatusClass(status: string): string {
    switch (status.toLowerCase()) {
      case 'completed':
        return 'bookingstatus';
      case 'pending':
        return 'bookingstatuspending';
      case 'confirmed':
        return 'bookingstatusupcoming';
      case 'inprogress':
        return 'bookingstatusupcoming';
      case 'cancelled':
        return 'bookingstatuscanceled';
      case 'expired':
        return 'bookingstatusexpired';
      default:
        return '';
    }
  }

  getStatusIcon(status: string): string {
    switch (status.toLowerCase()) {
      case 'completed':
        return 'assets/bookingIcon/Success.svg';
      case 'pending':
        return '/assets/bookingIcon/Pending.svg';
      case 'confirmed':
        return '/assets/bookingIcon/upcoming.svg';
      case 'cancelled':
        return '/assets/bookingIcon/Rejected.svg';
      case 'expired':
        return '/assets/bookingIcon/Pending.svg';
      case 'inprogress':
        return '/assets/userIcon/inprogress.svg';
      default:
        return '';
    }
  }

  onSearchAllChange(search: string) {
    this.searchAllSubject.next(search);
  }

  getRemainingDays(endDate: string): number {
    const today = new Date();
    const end = new Date(endDate);
    const diff = end.getTime() - today.getTime();
    return Math.max(0, Math.ceil(diff / (1000 * 3600 * 24)));
  }

  onSearchChange(value: string): void {
    this.searchSubject.next(value);
  }


  modifiedloadAllBookings(): void {
     
    this.bookingservice.getBookings(this.allPage, this.pageSize, this.searchAll, this.selecetedBookingStatus, this.selectedDateFilter, this.RegionFilter)
      .subscribe(res => {
        this.allBookings = res.items;
        this.BookingTotalCount = res.totalCount;




        this.totalbookingpage = Math.ceil(this.BookingTotalCount / this.pageSize);

        this.allbookingarray = Array.from({ length: this.totalbookingpage }, (_, i) => i + 1);
      });
  }
  goToPages(pageNumber: number): void {
    if (pageNumber >= 1 && pageNumber <= this.totalbookingpage) {
      this.allPage = pageNumber;
      this.modifiedloadAllBookings()
    }
  }

  onSizeChanges(newSize: number): void {
    this.pageSize = newSize;
    this.allPage = 1;
    this.modifiedloadAllBookings()
  }

  toggleViewdetails(view: 'tourdetails' | 'messages' | 'paymentdetails') {
    this.viewbooking = view;
  }





  getRegionName() {
    this.bookingservice.getRegionsWithIds().subscribe((res) => {
      this.regionsName = res;
    })
  }

  toggleView(view: 'allbooking' | 'upcoming' | 'complete' | 'canceled' | 'expired') {
    this.viewMode = view;
    this.pageNumber = 1;
    this.allbookingarray = []
    this.totalbookingpage = 0
    this.allBookings = []
    this.BookingTotalCount = 0
    this.allPage = 1
    this.pageSize = 10
    if (view == 'upcoming') {
      this.selecetedBookingStatus = 'Confirmed'
      this.modifiedloadAllBookings()

    }
    else if (view == 'complete') {
      this.selecetedBookingStatus = 'Completed'
      this.modifiedloadAllBookings()
    }
    else if (view == 'canceled') {
      this.selecetedBookingStatus = 'Cancelled'
      this.modifiedloadAllBookings()
    }
    else if (view == 'allbooking') {
      this.selecetedBookingStatus = ''
      this.modifiedloadAllBookings()
    }
    else if (view == 'expired') {
      this.selecetedBookingStatus = 'Expired'
      this.modifiedloadAllBookings()
    }
    else {
      return
    }

  }


  SetSelectedBooking(item: Booking) {
     
    this.selectedBooking = { ...item };

    this.viewbooking = 'tourdetails'
    this.toggleViewdetails
  }

  closeBookingOffCanava() {
     
    const tab1 = document.getElementById('tab1') as HTMLInputElement;
    if (tab1) {
      tab1.checked = true;
    }
    this.toursection = true
    this.paymentsection = false
    this.messagesection = false
    this.selectedBooking = null
    this.reasonvisiable = false
  }

  getChatHistory(user1Id: number, user2Id: number) {
    this.bookingservice.getAllChatHistory(user1Id, user2Id).subscribe((res) => {
      this.chatHistory = res

    })
  }




  occancelbooking() {
     
    this.userservice.getreasonforbooking().subscribe((res) => {

      this.getresonofcancel = res



    })
  }

  reasoncancelgo() {
     

    this.reasonvisiable = true

    this.occancelbooking()

  }

  reasonid: number = 0
  optionalreson: string = ''
  UserId: number = 0
  stringreason: string = ''
  getreasonid(reasonId: number, reasonstring: string) {
    this.reasonid = reasonId
    this.stringreason = reasonstring
  }

  cancelbooking() {
     
    this.confirmDialogService.openConfirmDialog('Are you sure you want to cancel this booking? This action will notify the tourist and the guide. Please select a reason to help us improve our services.', () => {
      if (this.selectedBooking?.bookingId === undefined || this.UserId === undefined || this.reasonid === undefined) {

        return;
      }
      this.userservice.cancelbookingbyadmin(this.selectedBooking?.bookingId, this.UserId, this.reasonid, this.optionalreson).subscribe((res) => {
        this.allBookings
        this.toaster.success("Cancel Booking successfully");
        this.closeBtn.nativeElement.click();

      })
    }, '/assets/userIcon/cancel.png')


  }

  sendcancelmailtotourist() {
     
    if (this.selectedBooking?.bookingId === undefined) {

      return;
    }
    this.bookingcanceldetails.bookingId = this.selectedBooking?.bookingId
    this.bookingcanceldetails.cancelledByRole = "Admin"
    this.bookingcanceldetails.reciversName = this.selectedBooking?.touristName
    this.bookingcanceldetails.sendToEmail = this.selectedBooking?.touristEmail
    this.bookingcanceldetails.touristName = this.selectedBooking?.touristName
    this.bookingcanceldetails.tourEndDate = this.selectedBooking?.tourEndDate
    this.bookingcanceldetails.tourstartDate = this.selectedBooking?.tourStartDate
    this.bookingcanceldetails.cancellationReason = this.stringreason
    this.bookingcanceldetails.cancelledOn = new Date().toISOString();
    this.bookingcanceldetails.tourGuideName = this.selectedBooking?.guideName
    this.bookingcanceldetails.tourDestination = this.selectedBooking?.tourLocation
    this.userservice.sendtomailoncancel(this.bookingcanceldetails).subscribe((res) => {




    })
  }



  sendcancelmailtotourguide() {
     
    if (this.selectedBooking?.bookingId === undefined) {

      return;
    }
    this.bookingcanceldetails.bookingId = this.selectedBooking?.bookingId
    this.bookingcanceldetails.cancelledByRole = "Admin"
    this.bookingcanceldetails.reciversName = this.selectedBooking?.touristName
    this.bookingcanceldetails.sendToEmail = this.selectedBooking?.tourGuideEmail
    this.bookingcanceldetails.touristName = this.selectedBooking?.touristName
    this.bookingcanceldetails.tourEndDate = this.selectedBooking?.tourEndDate
    this.bookingcanceldetails.tourstartDate = this.selectedBooking?.tourStartDate
    this.bookingcanceldetails.cancellationReason = this.stringreason
    this.bookingcanceldetails.cancelledOn = new Date().toISOString();
    this.bookingcanceldetails.tourGuideName = this.selectedBooking?.guideName
    this.bookingcanceldetails.tourDestination = this.selectedBooking?.tourLocation
    this.userservice.sendtomailoncancel(this.bookingcanceldetails).subscribe((res) => {




    })
  }
  formatPickupTime(pickupTime: string | undefined): string {
    if (!pickupTime) return '';


    const date = new Date(pickupTime);
    if (!isNaN(date.getTime())) {
      let hours = date.getHours();
      const minutes = date.getMinutes();
      const period = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12 || 12;
      return `${hours}:${minutes.toString().padStart(2, '0')} ${period}`;
    }


    const [hourStr, minuteStr] = pickupTime.split(':');
    let hours = parseInt(hourStr, 10);
    const minutes = parseInt(minuteStr, 10);
    const period = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12;
    return `${hours}:${minutes.toString().padStart(2, '0')} ${period}`;
  }
}



